import { defineStore } from "pinia";
import api from "@/api.js";
import metaPixel from "@/metaPixel.js";
import i18n from "@/i18n.js";

export const authStore = defineStore("auth", {
  state: () => ({
    passId: null,
    organization: {},
    organizationConfig: {},
    referralsEnabled: true,
    customFields: [],
    locations: [],
    branding: {},
    signupPage: {},
    signupElements: [],
    signupScript: {},
    currentCustomersByOrganizationId:
      JSON.parse(localStorage.getItem("currentCustomersByOrganizationId")) ||
      {},
    serviceWorkerRegistration: null,
    countryCode: "ES",
    appointment: null,
    reservation: null,
    interestingLinks: [],
  }),
  getters: {
    currentLocation() {
      return (
        this.locationsBySlug[this.slugNameOrLocationId] ||
        this.locationsById[this.slugNameOrLocationId]
      );
    },
    slugNameOrLocationId() {
      return this.router.currentRoute.value.params.slugNameOrLocationId;
    },
    deviceIsIphone() {
      return [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
        "MacIntel",
      ].includes(navigator.platform);
    },
    locationsBySlug() {
      return this.locations.reduce((res, location) => {
        res[location.slug] = location;
        return res;
      }, {});
    },
    locationsById() {
      return this.locations.reduce((res, location) => {
        res[location.id] = location;
        return res;
      }, {});
    },
    currentCustomer() {
      return (
        this.currentCustomersByOrganizationId[this.organization.id] || null
      );
    },
    customerId() {
      return this.currentCustomersByOrganizationId[this.organization.id]?.id;
    },
  },
  actions: {
    updateAppointment(appointment) {
      this.appointment = appointment;
    },
    updateReservation(reservation) {
      this.reservation = reservation;
    },
    async refreshSignupInfo() {
      let response = await api.get(
        `/signupPage/${this.router.currentRoute.value.params.shortenedSignupPageId}`
      );
      this.organization = response.data.organization;
      this.passId = response.data.passId;
      this.organizationConfig = response.data.organizationConfig;
      this.referralsEnabled = response.data.referralsEnabled !== false;
      this.branding = response.data.branding;
      this.signupElements = response.data.signupElements;
      this.signupPage = response.data.signupPage;
      this.signupScripts = response.data.signupScripts;
      this.locations = response.data.locations;
      this.customFields = response.data.customFields;
      this.interestingLinks = response.data.interestingLinks || [];
      this.countryCode =
        this.locations.find((l) => !!l.countryCode)?.countryCode || "ES";
      if (this.signupScripts?.metaPixelId) {
        metaPixel.load(this.signupScripts.metaPixelId, this.router);
      }
      i18n.global.locale.value = this.organizationConfig.language;
    },
    async refreshCountryCode() {
      try {
        let response = await api.get("/countryCode");
        if (response?.data?.countryCode) {
          this.countryCode = response.data.countryCode;
        }
      } catch (e) {
        console.error(e);
      }
    },
    updateCurrentCustomer(currentCustomer) {
      this.currentCustomersByOrganizationId = {
        ...this.currentCustomersByOrganizationId,
        [currentCustomer.organizationId]: currentCustomer,
      };
      localStorage.setItem(
        "currentCustomersByOrganizationId",
        JSON.stringify(this.currentCustomersByOrganizationId)
      );
    },
    updateServiceWorkerRegistration(registration) {
      this.serviceWorkerRegistration = registration;
    },
    removeCustomerInfoFromOrganization(organizationId) {
      delete this.currentCustomersByOrganizationId[organizationId];
      localStorage.setItem(
        "currentCustomersByOrganizationId",
        JSON.stringify(this.currentCustomersByOrganizationId)
      );
    },
  },
});
